import Grid from "@mui/joy/Grid";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import RequestsPane from "components/RequestsPane";

export default function RequestsRoute() {
    return (
        <Grid container
            columns={{ xs: 2, sm: 6, md: 12 }}
            sx={{ flexGrow: 1, width: "100%" }} >
            <Grid xs={8}>
                <RequestsPane />
            </Grid>
            <Grid xs={4}>
                <Stack m={1}
                    spacing={2}
                >
                    <Typography level="title-md">Requests</Typography>
                    <Typography level="body-md">
                        These are your requests from the standard service.
                    </Typography>
                </Stack>

            </Grid>
        </Grid>
    );

}
